import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Page from 'components/system/Page';
import Paper from 'components/system/Paper';
import colors from 'styles/colors';

const EmptySubmissions = () => (
  <Page>
    <Paper>
      <Box
        sx={{
          display: 'flex',
          height: '30vh',
          width: '100%',
          textAlign: 'center',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box>
          <Typography variant="h5" color={colors.text.primary}>
            No Submissions data
          </Typography>
        </Box>
      </Box>
    </Paper>
  </Page>
);

export default EmptySubmissions;
